let text="";
export const settext = (t) =>{

    text =t ;
}

export const gettext = () =>{

    return text;

} 
